import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";
import { Description } from "@material-ui/icons";

import TicketServiceEntryModal from "../TicketServiceEntryModal";

const useStyles = makeStyles(theme => ({
	actionButtons: {
		marginRight: 6,
		flex: "none",
		alignSelf: "center",
		marginLeft: "auto",
		"& > *": {
			margin: theme.spacing(1),
		},
	},
}));

const TicketActionButtons = ({ ticket }) => {
	const classes = useStyles();
	const [serviceModalOpen, setServiceModalOpen] = useState(false);

	return (
		<div className={classes.actionButtons}>
			<Tooltip title="Servicos / OS / Orcamentos / Comprovantes">
				<IconButton onClick={() => setServiceModalOpen(true)}>
					<Description />
				</IconButton>
			</Tooltip>
			<TicketServiceEntryModal
				open={serviceModalOpen}
				onClose={() => setServiceModalOpen(false)}
				ticket={ticket}
			/>
		</div>
	);
};

export default TicketActionButtons;
